import { render, staticRenderFns } from "./CardDetallePago.vue?vue&type=template&id=b8bbe49e&"
import script from "./CardDetallePago.vue?vue&type=script&lang=js&"
export * from "./CardDetallePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports